import { Flex } from '@chakra-ui/react';
import styled from '@emotion/styled';

export const WaveBackground = styled(Flex)`
  --mask: radial-gradient(19.16px at 50% -5.4px, #0000 99%, #000 101%) 50% -3px/34px
    102% repeat-x;
  -webkit-mask: var(--mask);
  mask: var(--mask);
  margin-top: -11px;
`;
